module.exports = __webpack_public_path__ + "img/gytsxdny.63004e48.png";